<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="APR/Graduation/Summary"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('apr_graduation_summary')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use
      APR/Graduation/Summary Tool. The APR/Graduation/Summary Tool displays
      retention and graduation summary by college, department.
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Admin Support Section
          <i class="fa-solid fa-arrow-right"></i> APR/Graduation/Summary
        </h1>

        <div class="buttons-nav">
          <div class="example-button-row">
            <nav-page-link
              text="Trend Filter Guide"
              targetId="formguide"
              tooltipMessage="Navigate down"
            ></nav-page-link>
            <span> &nbsp; | &nbsp; </span>
            <nav-page-link
              text="APR/Graduation/Summary Results"
              targetId="results"
              tooltipMessage="Navigate down"
            ></nav-page-link>
          </div>
        </div>

        <!---------- APR/Graduation/Summary Tool At First Glance ---------->
        <h3 class="h3-second-header">
          APR/Graduation/Summary Tool At First Glance
        </h3>

        <ol class="ordered-list">
          <li>
            Once you get to the page, you will be able to see something like the
            image below in Figure 34.
          </li>
        </ol>
        <br />

        <div>
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageAprGraduationSummaryFig34']"
            alt=""
          />
          <p class="picture-caption">
            Figure 34: Additional form fields with default inputs
          </p>
        </div>

        <div id="formguide"></div>
        <br />
        <mat-divider></mat-divider>
        <br />
      </div>

      <!---------- APR/Graduation/Summary Form Guide ---------->
      <div class="left-align-div">
        <h3 class="h3-second-header">APR/Graduation/Summary Form Submission</h3>

        <ol class="ordered-list">
          <li>
            Select a College (All; Lewis Bear Jr College of Business; College of
            Arts, Social Sciences and Humanities; Usha Kundu, MD College of
            Health; Hal Marcus of College of Science and Engineering; School of
            Education; No College Designated)
          </li>
          <li>
            Select a Department (Department form values are dependent on
            selecting a college)
          </li>
          <li>
            Select a Program (Program form values are dependent on selecting a
            department)
          </li>
          <li>
            Select a Cohort (2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022,
            2023, 2024)
          </li>
          <li>Select the range for High School GPA (0 - 5)</li>
          <li>Select a Demographic (None; Gender; First Gen)</li>
          <li>Click the submit button</li>
        </ol>
      </div>

      <div class="left-align-div">
        <p></p>
        <div>
          <img
            class="set-img-width-sm"
            [(src)]="env['logo_paths']['helpPageAprGraduationSummaryFig35']"
            alt=""
          />
          <p class="picture-caption">
            Figure 35: Default inputs for APR/Graduation/Summary form
          </p>
        </div>
      </div>

      <!--------------- Results After Form Submission Explanation --------------->
      <div class="left-align-div" id="results">
        <br />
        <mat-divider></mat-divider>
        <br />
        <h3 class="h3-second-header">Results after Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After submitting the form, you will see 1 table and 5 graphs like
            the screenshots (Figure 36, 37, 38, 38a) below. That shows you the
            trend of APR & retention & degree for the past years.
          </li>
          <li>
            You can also click on the colored boxes that’s below the graphs to
            remove any line/bar on the graphs based on the color.
          </li>
          <li>
            You can also download the results of the table by clicking on the
            button above the table.
          </li>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageAprGraduationSummaryFig36']"
              alt=""
            />
            <p class="picture-caption">
              Figure 36: APR/Graduation/Summary Table Result
            </p>
          </div>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageAprGraduationSummaryFig37']"
              alt=""
            />
            <p class="picture-caption">
              Figure 37: APR/Graduation/Summary First Graph Result
            </p>
          </div>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageAprGraduationSummaryFig38']"
              alt=""
            />
            <p class="picture-caption">
              Figure 38: APR/Graduation/Summary Second and Third Graph Result
            </p>
          </div>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageAprGraduationSummaryFig38a']"
              alt=""
            />
            <p class="picture-caption">
              Figure 38a: APR/Graduation/Summary Fourth and Fifth Graph Result
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getAdminSupportRelatedLinkBasedOnTool(
        'APR/Graduation/Summary',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
